export const SECTION_CAT_ITEMS_ACTION = 'SECTION_CAT_ITEMS_ACTION';
export const SECTION_CAT_ITEMS_SUCCESS_ACTION =
  'SECTION_CAT_ITEMS_SUCCESS_ACTION';
export const SECTION_CAT_ITEMS_FAILURE_ACTION =
  'SECTION_CAT_ITEMS_FAILURE_ACTION';
